(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .directive('protocolCategoryTable', ProtocolCategoryTableFn);

    /* protocol category table directive */
    ProtocolCategoryTableFn.$inject = [];

    function ProtocolCategoryTableFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/administration/modules/protocolcategories/templates/protocol-category-table.template.html',
            controller: 'ProtocolCategoryTableController',
            controllerAs: 'vm',
            bindToController: true           
        };
        return directive;

    }

})();